import React, { useEffect, useState } from "react";
import {
  findPaymentModeKey,
  initialForm,
  modes,
  paymentModeMapping,
  subModes as paymentModeGroup,
  paymentModeWithOutLoan,
} from "./constant";
import ModeChip from "./modesChip";
import { PopoverDropdown } from "./common";
import { allowedChangePaymentModeMapping } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/constant";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
const MostUsedModes = ({
  accessiblePaymentModeList = [],
  contextValue,
  isReceipt = false,
  oldPaymentMode = "",
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [borderIndex, setBorderIndex] = useState();
  const [subModesMenu, setSubModesMenu] = useState();

  let subModes = { ...paymentModeGroup };
  subModes =
    contextValue?.studentBasicDetails?.upFrontAmount > 0
      ? paymentModeWithOutLoan
      : subModes;

  const {
    setCurrentPaymentMode,
    setPaymentModeForm,
    setBalanceMode,
    currentPaymentMode,
    noAmountChange,
    collectPayment,
    paymentModeForm,
    collectVoucherList,
  } = contextValue;

  const isEPMRReceipt = (collectPayment || []).some(
    (item) => item?.isEmprReceipt
  );

  const isAutoCash = (collectPayment || []).some((item) => item?.isAutoCash);

  useEffect(() => {
    const payModeCode =
      paymentModeMapping[currentPaymentMode] ?? currentPaymentMode;
    let index = modes.findIndex(
      (item) =>
        item?.key == payModeCode ||
        (subModes?.[item?.key] &&
          subModes[item.key].find((el) => el.key == payModeCode))
    );
    // setBorderIndex((Object.keys(paymentMode)).indexOf(currentPaymentMode)-1)
    setBorderIndex(index);
  }, []);

  const paymentModeHandler = (item, e, index) => {
    if (subModes[item?.key]) {
      setBorderIndex(index);
      setSubModesMenu(subModes[item?.key]);
      handleClick(e);
    } else {
      if (checkReceiptCursor(item) == true) {
           setBorderIndex(index);
           paymentModeChangeHandler(item);
      } else {
        setBorderIndex(index);
        paymentModeChangeHandler(item);
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (item) => {
    
    if (isReceipt) {
      if (checkReceiptCursor(item)) {
        return paymentModeChangeHandler(item);
      } else {
        return failureToast("Not allowed for for this payment mode");
      }
    } else {
      paymentModeChangeHandler(item);
    }
  };

  const verifyAccessibleChip = (group) => {
    return (
      subModes[group].filter((item) =>
        accessiblePaymentModeList.includes(item?.key)&&item?.key!="QRC"
      ).length > 0
    );
  };

  const isPaymentModeUpdateAllowed = (item) => {
    const allowedMappingKey = oldPaymentMode;
    const allowedList = allowedChangePaymentModeMapping[allowedMappingKey];
    if ((allowedList || []).includes(item?.key?.toUpperCase())) {
      return true;
    }
    return false;
  };

  const checkCursor = (item) => {
    if (isEPMRReceipt) return false;

    if (subModes[item?.key]) return true;
    else {
      if (isReceipt) {
        return isPaymentModeUpdateAllowed(item);
      } else if (true) return true;
      else if (!paymentModeCollected) return true;
      else return false;
    }
  };
  const paymentModeChangeHandler = (item) => {
    const amount = paymentModeForm?.paidAmount;
    debugger
    noAmountChange
      ? setPaymentModeForm({ ...initialForm, paidAmount: amount })
      : setPaymentModeForm({ ...initialForm });
    setBalanceMode(false);
    setCurrentPaymentMode(findPaymentModeKey(item?.key));
  };
  const checkReceiptCursor = (item) => {
    if (isReceipt) {
      return isPaymentModeUpdateAllowed(item);
    } else return true;
  };

  const item = [...collectPayment, ...collectVoucherList];
  const paymentModeCollected =
    item.length > 0 && !isReceipt ? item[0].paymentMode : "";

  return (
    <>
      {modes.map((item, index) => (
        <div
          className={isEPMRReceipt || isAutoCash ? "disable-events-main" : ""}
          key={index}
          onClick={(e) => {
            paymentModeHandler(item, e, index);
          }}
        >
          {(accessiblePaymentModeList.includes(item?.key) ||
            (subModes?.[item.key] && verifyAccessibleChip(item?.key))) && (
            <ModeChip
              key={index}
              icon={item?.icon}
              text={item?.text}
              className={checkCursor(item) ? "cursor" : "disable-events"}
              style={
                borderIndex == index
                  ? {
                      border: "2px solid #0F0F0F",
                      color: "#0F0F0F",
                      //fontSize: "16px",
                      fontWeight: "600",
                    }
                  : {}
              }
            />
          )}
        </div>
      ))}
      <PopoverDropdown
        paymentModeCollected={paymentModeCollected}
        handleChange={handleChange}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        dropdownMenu={subModesMenu}
        accessiblePaymentModeList={accessiblePaymentModeList}
        checkReceiptCursor={checkReceiptCursor}
      />
    </>
  );
};
export default MostUsedModes;
